// import helpers from '../common/helpers';


(function ($) {
  "use strict";

  const cntsNewsPosts = {
    init: function () {
      this.setup();
      this.start();
    },
    setup() {
      this.options = {
        $postsGrid: $('.post-grid'),
      };
    },
    start() {
      cntsNewsPosts.gridPosts();
    },

    carouselTestimonials() {
      const { $owlCarouselTestimonials } = this.options;

      $owlCarouselTestimonials.owlCarousel({
        loop: false,
        margin: 10,
        nav: false,
        dots: true,
        items: 1
      })
    },

    gridPosts() {
      const { $postsGrid } = this.options;

      if (!$('body').hasClass('cnts--mobile')) {
        $postsGrid.masonry({
          itemSelector: '.post-grid__item',
          columnWidth: '.post-grid--sizer',
          gutter: 20,
          percentPosition: true
        });

      } else {
        $postsGrid.masonry('destroy')
      }
    }
  };

  $(document).ready(function () {

    if($('body').hasClass('page-template-page-news')){
      cntsNewsPosts.init();
    }
  });

  $(window).resize(function () {
    // cntsNewsPosts.carouselPostCards();
  });

})(jQuery);